import Alert from './Alert';
import PropTypes from 'prop-types';

const AlertInfo = ({ alerts, mode, searchTerm }) => {
    return (
        <div>
            {alerts.map(({ color, note, name, accessPeriod }) => {
                return (
                    <div key={name}>
                        <Alert name={name} color={color} note={note} mode={mode} accessPeriod={accessPeriod} searchTerm={searchTerm} />
                    </div>
                );
            })}
        </div>
    );
};

export default AlertInfo;

AlertInfo.propTypes = {
    alerts: PropTypes.arrayOf(
        PropTypes.shape({
            color: PropTypes.string,
            note: PropTypes.string,
            name: PropTypes.string,
            accessPeriod: PropTypes.object,
        })
    ).isRequired,
    mode: PropTypes.string,
    searchTerm: PropTypes.string,
};
